import { useSelector } from 'react-redux';
import { useRouteLoaderData } from 'react-router';
import { deepEqual } from '../../../../../common/utils/objectUtils';
import { pendingSubscriptionActionExistsInState } from '../../../../../common/utils/subscriptionUtils';
import { DeviceChangeRequestDisclaimer } from '../../../../../components/SubscriptionDetails/Components/DeviceChangeRequestDisclaimer';
import { SubscriptionBillingAccountUserInformation } from '../../../../../components/SubscriptionDetails/SubscriptionBillingAccountUserInformation';
import { DeviceLayout } from '../../../../../components/SubscriptionLayout/DeviceLayout';
import type { DeviceSubscriptionLoaderResponse } from '../../../../../common/loaders';
import type { State } from '../../../../../selfservice/common/store';

export const DeviceBillingAccountUserInformationPath = () => {
  const {
    billingAccounts,
    companyInfo,
    contacts,
    hasPendingActions,
    hasPendingAdminReview,
    subscription,
    billChannels,
    subscriptionScheduledChanges,
  } = useRouteLoaderData('deviceSub') as DeviceSubscriptionLoaderResponse;
  const subscriptionActionsState = useSelector((s: State) => s?.selfservice?.pendingSubscriptionActions, deepEqual);
  const hasPendingChanges =
    hasPendingActions || pendingSubscriptionActionExistsInState(subscription.subscriptionId, subscriptionActionsState);
  const changeRequestDisclaimer = hasPendingChanges ? <DeviceChangeRequestDisclaimer /> : null;

  return (
    <DeviceLayout companyInfo={companyInfo} subscription={subscription} hasPendingAdminReview={hasPendingAdminReview}>
      <SubscriptionBillingAccountUserInformation
        subscription={subscription}
        hasPendingActions={hasPendingChanges}
        companyInfo={companyInfo}
        billingAccounts={billingAccounts}
        contacts={contacts}
        disclaimerContent={changeRequestDisclaimer}
        billChannels={billChannels}
        subscriptionScheduledChanges={subscriptionScheduledChanges}
      />
    </DeviceLayout>
  );
};
